// extracted by mini-css-extract-plugin
export default {"Container":"CheckBox_Container__RRZ7O","CheckBox":"CheckBox_CheckBox__LuN2w"};